import { Subject } from "rxjs";


/**
 * Class existing only to hold this Subject variable,
 * used to notify listeners when the login status has changed
 */
export class LoginHelper {

  private isUserLoggedIn: Subject<boolean> = new Subject<boolean>();
  private loginRequired: Subject<void> = new Subject<void>();

  private static instance: LoginHelper = new LoginHelper();

  public static getInstance(): LoginHelper {
    return this.instance;
  }

  private constructor() { }

  getSubject(): Subject<boolean> {
    return this.isUserLoggedIn;
  }

  getLoginRequiredSubject(): Subject<void> {
    return this.loginRequired;
  }

  loginChanged(value: boolean) {
    this.isUserLoggedIn.next(value);
  }

  /**
   * Trigger register modal to open (e.g. when non-logged-in user clicks on wishlist button)
   */
  requestLogin() {
    this.loginRequired.next();
  }

  static getUrlWithoutSessionToken(url: string): string {

    if(!url){
      return "";
    }

    //If there is a token in the url, remove it and reload the page
    let urlParts = url.split(';');
    if(urlParts && urlParts.length > 1){
      return urlParts[0];
    }
    return url;
  }

}
